"use strict";

var _defineProperty = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleAccountFetcher = void 0;
const address_util_1 = require("../../address-util");
const account_requests_1 = require("../account-requests");
class SimpleAccountFetcher {
  constructor(connection, retentionPolicy) {
    _defineProperty(this, "connection", void 0);
    _defineProperty(this, "retentionPolicy", void 0);
    _defineProperty(this, "cache", new Map());
    this.connection = connection;
    this.retentionPolicy = retentionPolicy;
    this.cache = new Map();
  }
  async getAccount(address, parser, opts) {
    var _cached$fetchedAt;
    let now = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Date.now();
    const addressKey = address_util_1.AddressUtil.toPubKey(address);
    const addressStr = address_util_1.AddressUtil.toString(address);
    const cached = this.cache.get(addressStr);
    const maxAge = this.getMaxAge(this.retentionPolicy.get(parser), opts);
    const elapsed = !!cached ? now - ((_cached$fetchedAt = cached === null || cached === void 0 ? void 0 : cached.fetchedAt) !== null && _cached$fetchedAt !== void 0 ? _cached$fetchedAt : 0) : Number.NEGATIVE_INFINITY;
    const expired = elapsed > maxAge;
    if (!!cached && !expired) {
      return cached.value;
    }
    try {
      const accountInfo = await this.connection.getAccountInfo(addressKey);
      const value = parser.parse(addressKey, accountInfo);
      this.cache.set(addressStr, {
        parser,
        value,
        fetchedAt: now
      });
      return value;
    } catch (_unused) {
      this.cache.set(addressStr, {
        parser,
        value: null,
        fetchedAt: now
      });
      return null;
    }
  }
  getMaxAge(parserMaxAge, opts) {
    if ((opts === null || opts === void 0 ? void 0 : opts.maxAge) !== undefined) {
      return opts.maxAge;
    }
    return parserMaxAge === undefined ? Number.POSITIVE_INFINITY : parserMaxAge;
  }
  async getAccounts(addresses, parser, opts) {
    let now = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Date.now();
    const addressStrs = address_util_1.AddressUtil.toStrings(addresses);
    await this.fetchAndPopulateCache(addressStrs, parser, opts, now);
    const result = new Map();
    addressStrs.forEach(addressStr => {
      const cached = this.cache.get(addressStr);
      const value = cached === null || cached === void 0 ? void 0 : cached.value;
      result.set(addressStr, value);
    });
    return result;
  }
  async getAccountsAsArray(addresses, parser, opts) {
    let now = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Date.now();
    const addressStrs = address_util_1.AddressUtil.toStrings(addresses);
    await this.fetchAndPopulateCache(addressStrs, parser, opts, now);
    const result = new Array();
    addressStrs.forEach(addressStr => {
      const cached = this.cache.get(addressStr);
      const value = cached === null || cached === void 0 ? void 0 : cached.value;
      result.push(value);
    });
    return result;
  }
  populateAccounts(accounts, parser, now) {
    Array.from(accounts.entries()).forEach(_ref => {
      let [key, value] = _ref;
      this.cache.set(key, {
        parser,
        value,
        fetchedAt: now
      });
    });
  }
  async refreshAll() {
    let now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
    let timeoutInSeconds = arguments.length > 1 ? arguments[1] : undefined;
    const addresses = Array.from(this.cache.keys());
    const fetchedAccountsMap = await (0, account_requests_1.getMultipleAccountsInMap)(this.connection, addresses, timeoutInSeconds);
    for (const [key, cachedContent] of this.cache.entries()) {
      const parser = cachedContent.parser;
      const fetchedEntry = fetchedAccountsMap.get(key);
      const value = parser.parse(address_util_1.AddressUtil.toPubKey(key), fetchedEntry);
      this.cache.set(key, {
        parser,
        value,
        fetchedAt: now
      });
    }
  }
  async fetchAndPopulateCache(addresses, parser, opts) {
    let now = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Date.now();
    const addressStrs = address_util_1.AddressUtil.toStrings(addresses);
    const maxAge = this.getMaxAge(this.retentionPolicy.get(parser), opts);
    const undefinedAccounts = addressStrs.filter(addressStr => {
      var _cached$fetchedAt2;
      const cached = this.cache.get(addressStr);
      const elapsed = !!cached ? now - ((_cached$fetchedAt2 = cached === null || cached === void 0 ? void 0 : cached.fetchedAt) !== null && _cached$fetchedAt2 !== void 0 ? _cached$fetchedAt2 : 0) : Number.NEGATIVE_INFINITY;
      const expired = elapsed > maxAge;
      return !cached || expired;
    });
    if (undefinedAccounts.length > 0) {
      const fetchedAccountsMap = await (0, account_requests_1.getMultipleAccountsInMap)(this.connection, undefinedAccounts, opts === null || opts === void 0 ? void 0 : opts.timeoutInSeconds);
      undefinedAccounts.forEach(key => {
        const fetchedEntry = fetchedAccountsMap.get(key);
        const value = parser.parse(address_util_1.AddressUtil.toPubKey(key), fetchedEntry);
        this.cache.set(key, {
          parser,
          value,
          fetchedAt: now
        });
      });
    }
  }
}
exports.SimpleAccountFetcher = SimpleAccountFetcher;
//# sourceMappingURL=simple-fetcher-impl.js.map